// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "\n.logo-pgm[data-v-69d852e9] { width: 120px\n}\n.stone-rebrand-logo[data-v-69d852e9] { height: 32px; width: auto;\n}\n", ""]);
// Exports
module.exports = exports;
